<template>
  <i class="icon_wrap"></i>
</template>

<script>
export default {
  name: 'WeChatIcon'
};
</script>

<style scoped lang="stylus">
.icon_wrap {
  display inline-block
  width 64px
  height 64px
  background-size 64px 64px
  background-repeat no-repeat
  background-position center
  background-image url('./images/pra_icon_sheet_failed@3x.png')
}
</style>
